import { createContext, Dispatch, SetStateAction } from 'react';

import { FormInstance } from 'antd';

import { StepTwoFormFields } from './StepTwoFormProvider';

import { SelectOption } from '../../../../../../../../../shared/interfaces';
import { PLAN_TYPE } from '../../../../../shared';

interface StepTwoFormContextProps {
  activeKey:                          any;
  addNewTab:                          (id?: number) => void;
  areTabActionsAllowed:               boolean;
  civilFormValues:                    StepTwoFormFields | null;
  duplicateTab:                       (id?: number) => void;
  filterPlansByPlanTypeSelected:      () => void;
  isPlanTypeADisabled:                boolean;
  isPlanTypeCDisabled:                boolean;
  keyTabToDelete:                     number | null;
  planOptionsBySelectedPlan:          Array<SelectOption>;
  planTypeSelected:                   PLAN_TYPE;
  removeTab:                          (id?: any) => void;
  resetTabs:                          (unconfirmedPlanType: PLAN_TYPE) => void;
  setActiveKey:                       Dispatch<SetStateAction<any>>;
  setCivilFormValues:                 Dispatch<SetStateAction<StepTwoFormFields | null>>;
  setKeyTabToDelete:                  Dispatch<SetStateAction<number | null>>;
  setPlanTypeSelected:                Dispatch<SetStateAction<PLAN_TYPE>>;
  setShowModal:                       Dispatch<SetStateAction<boolean>>;
  setTabs:                            Dispatch<SetStateAction<Array<any>>>;
  showModal:                          boolean;
  stepTwoForm:                        FormInstance<any> | undefined;
  tabs:                               Array<any>;
}

export const StepTwoFormContext = createContext({} as StepTwoFormContextProps);
